import styled from 'styled-components';
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails, Typography } from '@mui/material';
import COLOR from 'utils/constants/color';

export const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    width:90vw;
    height:90vh;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

export const ModalSection = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    width:90vw;
    height:100%;
    overflow:auto;
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
`;

export const AccordianTitle = styled(Typography)`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    width:100%;
`;

export const Accordion = styled(MuiAccordion)(({ theme }) => ({
    border: '1px solid white',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: 'auto',
    },
  }));
  
export const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
    backgroundColor: '#03989e',
    color: 'white',
    textTransform: 'capitalize',
    borderBottom: '1px solid white',
    marginBottom: -1,
    minHeight: 30,
    '&.Mui-expanded': {
      minHeight: 30,
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '8px 0',
    },
  }));
  
export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: '2px',
  }));

export const Rotate = styled.div`
    align-items: center;
    display: flex;
    height: 16px;
    justify-content: center;
    margin-right: 4px;
    transform: ${p => p.open ? 'rotate(90deg)' : 'rotate(0deg)'};
    transition: all 300ms ease;
    width: 16px;
`;

export const ContentArea = styled.div`
    width: 90%;
    margin-top: 28px;
`;
